import { get, post } from './http'
export const getSTokens = () => get('/v1_upload/sts/token', {}, false)

export const uploadFileV2 = (formData, config = {}) => {
    return post('/v1_upload/upload', formData, false, config)
}

export const mergeFileV2 = formData => {
    return post('/v1_upload/merge/chunk', formData, false)
}

export const deleteFileV2 = data => {
    return post('/v1_upload/file/delete', data)
}
